import { createCrudApi } from './crud';

export type SiteStatus = 'active' | 'inactive' | 'completed' | 'closed';

export interface Site {
  id: number;
  siteCode: string;
  omsId: number | null;
  clientId: number;
  projectId: number;
  siteName: string;
  address: string | null;
  latitude: number | null;
  longitude: number | null;
  status: SiteStatus;
  createdAt: string;
}

export interface CreateSiteInput {
  projectId: number;
  siteName: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  status?: SiteStatus;
}

// projectId is immutable; update payload omits it.
export type UpdateSiteInput = Omit<Partial<CreateSiteInput>, 'projectId'>;

export const sitesApi = createCrudApi<Site, CreateSiteInput, UpdateSiteInput>('sites');
